<div class="message-access-restricted" role="alert">
  <div></div>
  <div>
    <strong> {{ 'accessRestricted.title' | transloco }} </strong><br /><br />
    {{ 'accessRestricted.message' | transloco }} <br /><br />
    {{ 'accessRestricted.contactSupportAt' | transloco }}
    <a [href]="'mailto:' + constants.supportEmail">{{ constants.supportEmail }}</a>
    {{ 'license.orVisit' | transloco }}
    <a [href]="constants.supportUrl" target="_blank">{{ constants.supportUrl }}</a>
    {{ 'license.forAssistance' | transloco }} <br /><br />{{ 'license.thanks' | transloco }}
  </div>
</div>
